module.exports = __webpack_public_path__ + "c237ce3f42d28ddee5fb5b268a23b767.png";